import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const PersonTextRectangleIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M2.91 4 2 4.912v14.176l.91.912h18.18l.91-.912V4.912L21.09 4H2.91Zm7.07 6.02c0 .84-.679 1.52-1.515 1.52-.837 0-1.516-.68-1.516-1.52S7.629 8.5 8.465 8.5c.836 0 1.515.68 1.515 1.52Zm3.03 1.42h5.05V9.614h-5.05v1.824Zm5.05 3.04h-5.05v-1.825h5.05v1.825Zm-12.12-.636c0-1.12.904-2.027 2.02-2.027h1.01c1.115 0 2.02.908 2.02 2.027v1.014H5.94v-1.014Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M18.06 11.44h-5.05V9.614h5.05v1.824ZM13.01 14.48h5.05v-1.825h-5.05v1.825ZM9.98 10.02c0 .84-.679 1.52-1.515 1.52-.837 0-1.516-.68-1.516-1.52S7.628 8.5 8.465 8.5c.836 0 1.515.68 1.515 1.52ZM7.96 11.817c-1.116 0-2.02.908-2.02 2.027v1.014h5.05v-1.014c0-1.12-.905-2.027-2.02-2.027H7.96Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M2 4.912 2.91 4h18.18l.91.912v14.176l-.91.912H2.91L2 19.088V4.912Zm1.818.912v12.352h16.364V5.824H3.818Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `PersonTextRectangleIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { PersonTextRectangleIcon };
//# sourceMappingURL=PersonTextRectangleIcon.mjs.map
